module.exports = __webpack_public_path__ + "img/banner05.d4398c22.jpg";